import { render, staticRenderFns } from "./live-item-s.vue?vue&type=template&id=8ea8d196&scoped=true"
import script from "./live-item-s.vue?vue&type=script&lang=js"
export * from "./live-item-s.vue?vue&type=script&lang=js"
import style0 from "./live-item-s.vue?vue&type=style&index=0&id=8ea8d196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea8d196",
  null
  
)

export default component.exports